import { DatePicker as AntDatePicker } from 'antd';
import { RangePickerProps as RangePickerPropsType } from 'antd/lib/date-picker';
import { useTranslation } from 'react-i18next';
import { getDateFormatForLocales } from 'src/formio/components/Datetime/utils';
import styled from 'styled-components';

type RangePickerProps = RangePickerPropsType & {
    'data-testid'?: string;
};

export const DateRangePicker = ({
    'data-testid': dataTestId = 'date-range-picker',
    ...props
}: RangePickerProps) => {
    const { t } = useTranslation();

    return (
        <StyledDateRangeWrapper>
            <AntDatePicker.RangePicker
                placeholder={[
                    t('Component.DateRangePicker.Start'),
                    t('Component.DateRangePicker.End'),
                ]}
                format={getDateFormatForLocales().appFormat}
                panelRender={(panel) => (
                    <div data-testid={`${dataTestId}-panel`}>{panel}</div>
                )}
                {...props}
            />
        </StyledDateRangeWrapper>
    );
};

const StyledDateRangeWrapper = styled.div`
    .ant-picker {
        border: 1px solid var(--input-border-color);
    }

    .ant-picker-input > input {
        font-size: 1rem;
        color: var(--text-color);

        &::placeholder {
            color: var(--text-color);
        }
    }

    .ant-picker-separator {
        display: flex;
        align-items: center;
        color: var(--text-color);
    }

    .ant-picker-suffix {
        display: none;
    }

    .ant-picker-focused {
        box-shadow: none;
        border-color: var(--input-border-color-focus);
    }

    .ant-picker-active-bar {
        display: none;
    }
`;
